export interface IDrawerMenuState {
  openDrawer: boolean;
  activePath: string;
}

export const DefaultDrawerMenuState: IDrawerMenuState = {
  openDrawer: false,
  activePath: 'mitigation'
};
